import { render, staticRenderFns } from "./personal_projects_tab.vue?vue&type=template&id=3696b90c"
import script from "./personal_projects_tab.vue?vue&type=script&lang=js"
export * from "./personal_projects_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports